import { useLingui } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import { Button } from '@utima/ui';
import { AlertCircle } from 'lucide-react';

export type ErrorProps = {
  statusCode: number;
  title: string;
  description: string;
};

export function Error({ statusCode, title, description }: ErrorProps) {
  const { t } = useLingui();

  return (
    <div className='flex min-h-screen flex-col items-center justify-center'>
      <div className='text-center'>
        <AlertCircle className='mx-auto mb-4 size-12 text-danger' />
        <h1 className='text-4xl font-bold'>{statusCode}</h1>
        <h2 className='mt-2 text-xl font-semibold'>{title}</h2>
        <p className='mt-2 text-muted-fg'>{description}</p>
        <Button
          data-cta='admin-error-back-to-homepage'
          asChild
          className='mt-6'
        >
          <Link to='/'>{t`Back to homepage`}</Link>
        </Button>
      </div>
    </div>
  );
}
